import { ConfigPublic } from '@/common/config.public';
import { elysiumLogger } from '@/common/utils/sharedUtils';
import { noImageUrl } from '@/modules/Lumino/LuminoPage/constants';
import { ImageSrcSet, TagV2 } from 'generatedBfw/static';

export const RouteToSeoTag = (tag: TagV2) => {
  if (!tag.slug || !tag.type) {
    elysiumLogger().error(`Missing tag slug or type, slug:${tag.slug} type:${tag.type}`);
    return ``;
  }
  return `/${tag.type}/${tag.slug}`;
};

export const RouteToHRImage = (internalId: number) => {
  return `/hdisplatesdownload/${internalId}`;
};

export const RouteToOriginalImage = (internalId: number) => {
  return `/admin/hdisplates/${internalId}`;
};

/**
 * Returns path to static images. On local build these are in /public but on production builds its on s3
 * @param path image path starting with /
 * @returns
 */
export const StaticImage = (path: string): string => {
  return `${ConfigPublic.PublicAssetsPrefix}/next-assets/public${path}`;
};

/**
 * Returns path to static files. On local build these are in /public but on production builds it's on s3
 * @param path image path starting with /
 * @returns url to the file depedning on environment
 */
export const StaticFile = (path: string): string => {
  return `${ConfigPublic.PublicAssetsPrefix}/next-assets/public/files${path}`;
};

/**
 * Returns static images as srcSet. On local build these are in /public but on production builds its on s3
 * @returns
 */
export const StaticResolutionsSrcSet = (x1Path: string, x2Path?: string): string => {
  if (!x1Path) {
    elysiumLogger().error('StaticResolutionsSrcSet: x1Path is undefined');
    return `${StaticImage(noImageUrl)} 1x`;
  }
  if (!x2Path) return `${StaticImage(x1Path)} 1x`;

  return `${StaticImage(x1Path)} 1x, ${StaticImage(x2Path)} 2x`;
};

/**
 * Returns images from bfw (dynamic) as srcSet.
 * @returns
 */
export const ResolutionsSrcSet = (srcSet: ImageSrcSet): string => {
  if (!srcSet.x1) {
    elysiumLogger().error('StaticResolutionsSrcSet: x1Path is undefined');
    return `${StaticImage(noImageUrl)} 1x`;
  }
  if (!srcSet.x2) return `${srcSet.x1} 1x`;

  return `${srcSet.x1} 1x, ${srcSet.x2} 2x`;
};
